define( function() {
	return [];
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/var/arr.js
 ** module id = 818
 ** module chunks = 2
 **/